const GENDER_TYPES = {
  male: 'm',
  female: 'f',
  other: 'other',
};

export default GENDER_TYPES;
